import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { BlockReasonModal } from '../BlockReasonModal';
import { CustomerTableResponsiveProps } from '../models';

import { InvalidColumns } from './components/InvalidColumns';
import { CustomerDesktopTable } from './desktop';
import { CustomerMobileTable } from './mobile';
import { CustomerTabletTable } from './tablet';

export const ResponsiveTable: React.FC<CustomerTableResponsiveProps> = (props) => {
  const isSearch = props.ListBySearchTerm && props.ListBySearchTerm?.length > 0;
  const data = isSearch ? props.ListBySearchTerm : props.ListAll;

  const tableProps = { ...props, data };

  const responsiveTable = useBreakpointValue({
    base: <CustomerMobileTable {...tableProps} />,
    sm: <CustomerTabletTable {...tableProps} />,
    lg: <CustomerDesktopTable {...tableProps} isSearch={isSearch} />,
  });

  if (props.invalidColumns) {
    return <InvalidColumns />;
  }

  return (
    <>
      {responsiveTable}
      <BlockReasonModal />
    </>
  );
};
